// src/tasks/lib/tasks-nav.ts
// Task management R1: the Tasks rail tile, shown only with the `?x=tasks` switch on in this browser (tasks-switch.ts).
import type { PractitionerNavItem } from '@scripsteam/scrips-signal-ds';

export const TASKS_NAV_ITEM: PractitionerNavItem = { id: 'tasks', label: 'Tasks', icon: 'clipboard' };

/** The rail's tiles: the canonical set, plus Tasks when its switch is on. */
export const navItems = (base: PractitionerNavItem[], tasksOn: boolean): PractitionerNavItem[] => (tasksOn ? [...base, TASKS_NAV_ITEM] : base);
